// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webmapp-modalstoresuccess {
  padding: 16px;
}
.webmapp-modalstoresuccess .webmapp-modalstoresuccess-title {
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-xxxlg);
  color: var(--wm-color-dark);
  padding-top: 5px;
  display: block;
}
.webmapp-modalstoresuccess .webmapp-modalstoresuccess-image {
  padding: 40px;
}
.webmapp-modalstoresuccess .webmapp-modalstoresuccess-info-main {
  padding-top: 30px;
  padding-left: 30px;
  display: inline-block;
  font-size: var(--wm-font-md);
  color: var(--wm-color-dark);
}
.webmapp-modalstoresuccess .webmapp-modalstoresuccess-info-sub {
  padding-top: 30px;
  padding-left: 30px;
  display: inline-block;
  font-size: var(--wm-font-md);
  color: var(--wm-color-dark);
}
.webmapp-modalstoresuccess .wwebmapp-modalstoresuccess-buttoncontainer {
  text-align: center;
  padding: 20px;
}
.webmapp-modalstoresuccess .wwebmapp-modalstoresuccess-buttoncontainer .wwebmapp-modalstoresuccess-buttondownload {
  --border-radius: 20px;
  margin: 20px 0;
}
.webmapp-modalstoresuccess .wwebmapp-modalstoresuccess-buttoncontainer .wwebmapp-modalstoresuccess-buttondownload .webmapp-modalstoresuccess-buttondownload-icon {
  margin-right: 15px;
  margin-left: 15px;
}
.webmapp-modalstoresuccess .wwebmapp-modalstoresuccess-buttoncontainer .webmapp-modalstoresuccess-buttonor {
  display: block;
  padding: 30px;
  font-size: var(--wm-font-sm);
  color: var(--wm-color-grey);
}
.webmapp-modalstoresuccess .wwebmapp-modalstoresuccess-buttoncontainer .webmapp-modalstoresuccess-anchorback {
  color: var(--wm-color-secondary);
  font-weight: var(--wm-font-weight-bold);
  font-size: var(--wm-font-md);
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-store-success/modal-store-success.component.scss"],"names":[],"mappings":"AAEA;EAII,aAAA;AAJJ;AAMI;EACI,uCAAA;EACA,+BAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;AAJR;AAOI;EACI,aAAA;AALR;AAQI;EACI,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AANR;AASI;EACI,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;AAPR;AAUI;EACI,kBAAA;EACA,aAAA;AARR;AAUQ;EACI,qBAAA;EACA,cAAA;AARZ;AASY;EACI,kBAAA;EACA,iBAAA;AAPhB;AAWQ;EACI,cAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;AATZ;AAYQ;EACI,gCAAA;EACA,uCAAA;EACA,4BAAA;AAVZ","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.webmapp-modalstoresuccess {\n    //   width: 100%;\n    //   height: 100%;\n    //   --background: var(--wm-color-secondary);\n    padding: 16px;\n\n    .webmapp-modalstoresuccess-title {\n        font-weight: var(--wm-font-weight-bold);\n        font-size: var(--wm-font-xxxlg);\n        color: var(--wm-color-dark);\n        padding-top: 5px;\n        display: block;\n    }\n\n    .webmapp-modalstoresuccess-image {\n        padding: 40px;\n    }\n\n    .webmapp-modalstoresuccess-info-main {\n        padding-top: 30px;\n        padding-left: 30px;\n        display: inline-block;\n        font-size: var(--wm-font-md);\n        color: var(--wm-color-dark);\n    }\n\n    .webmapp-modalstoresuccess-info-sub {\n        padding-top: 30px;\n        padding-left: 30px;\n        display: inline-block;\n        font-size: var(--wm-font-md);\n        color: var(--wm-color-dark);\n    }\n\n    .wwebmapp-modalstoresuccess-buttoncontainer {\n        text-align: center;\n        padding: 20px;\n\n        .wwebmapp-modalstoresuccess-buttondownload {\n            --border-radius: 20px;\n            margin: 20px 0;\n            .webmapp-modalstoresuccess-buttondownload-icon {\n                margin-right: 15px;\n                margin-left: 15px;\n            }\n        }\n\n        .webmapp-modalstoresuccess-buttonor {\n            display: block;\n            padding: 30px;\n            font-size: var(--wm-font-sm);\n            color: var(--wm-color-grey);\n        }\n\n        .webmapp-modalstoresuccess-anchorback {\n            color: var(--wm-color-secondary);\n            font-weight: var(--wm-font-weight-bold);\n            font-size: var(--wm-font-md);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
